import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';

export const DynamicInvoice: FC<BaseSvgProps> = ({ 'data-testid': testId }) => (
  <svg
    width={14}
    height={18}
    viewBox="0 0 18 24"
    fill="none"
    className="shrink-0"
    data-testid={testId}
  >
    <mask
      id="mask0_dynamic_invoice"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="24"
    >
      <rect width="18" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_dynamic_invoice)">
      <path
        d="M11.5 6C11.5 6.27614 11.7239 6.5 12 6.5H18V23.5C18 23.7761 17.7761 24 17.5 24H0.5C0.223858 24 8.05326e-09 23.7761 0 23.5V0.5C0 0.223858 0.223858 8.05324e-09 0.5 0H11.5V6Z"
        fill="currentColor"
      />
      <path
        d="M12.25 0.301777V5.625C12.25 5.69404 12.306 5.75 12.375 5.75L17.6982 5.75C17.8096 5.75 17.8654 5.61536 17.7866 5.53661L12.4634 0.213388C12.3846 0.134643 12.25 0.190413 12.25 0.301777Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
